import { customAxios } from '../../common/customAxios';

export interface PostCustomerInquiriesParams {
  reqBody: {
    category: string;
    phoneNumber: string;
    type?: string;
    content?: string;
    metadata?: (string | number)[];
  };
}

export const postCustomerInquiries = ({ reqBody }: PostCustomerInquiriesParams): Promise<void> => {
  return customAxios.post('/customer-inquiries', reqBody);
};
